import { combineReducers } from 'redux';
import { persistReducer } from 'redux-persist';
import storage from 'redux-persist/lib/storage';
// slices
import mailReducer from './slices/mail';
import chatReducer from './slices/chat';
import productReducer from './slices/product';
import calendarReducer from './slices/calendar';
import kanbanReducer from './slices/kanban';
import auctionReducer from './slices/auction';
import userReducer from './slices/user';
import orderReducer from './slices/order';
import settingReducer from './slices/setting';
import attributeReducer from './slices/attribute';
import statisticReducer from './slices/statistic';

// ----------------------------------------------------------------------

const rootPersistConfig = {
  key: 'root',
  storage,
  keyPrefix: 'redux-',
  whitelist: [],
};

const productPersistConfig = {
  key: 'product',
  storage,
  keyPrefix: 'redux-',
  whitelist: ['sortBy', 'checkout'],
};

const auctionPersistConfig = {
  key: 'auction',
  storage,
  keyPrefix: 'redux-',
  whitelist: ['sortBy'],
};

const rootReducer = combineReducers({
  mail: mailReducer,
  chat: chatReducer,
  calendar: calendarReducer,
  kanban: kanbanReducer,
  user: userReducer,
  order: orderReducer,
  setting: settingReducer,
  attribute: attributeReducer,
  product: persistReducer(productPersistConfig, productReducer),
  auction: persistReducer(auctionPersistConfig, auctionReducer),
  statistic: statisticReducer,
});

export { rootPersistConfig, rootReducer };
